const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';
const SYSTEM_SETUP = 'SYSTEM_SETUP';

export {LOGOUT,LOGIN, SYSTEM_SETUP};